// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__46CSo","pagination":"Pagination_pagination__RkAz_","button":"Pagination_button__nJGgK","buttonActive":"Pagination_buttonActive__g0nhC"};